import React, { useEffect, useState } from 'react';
import axios from 'config/axios';
import Helmet from 'components/Helmet';
import { useAppDispatch } from 'hooks/useStore';
import { updateClassroom } from 'store/classroom';
import { setAlert } from 'store/error';
import { Bundle, Test } from 'global/types';

import MyTests from '../MyTests';
import NewTests from '../NewTests';
import './index.css';

function PSAT() {
    const [tabIndex, setTabIndex] = useState(0);
    const [myTests, setMyTests] = useState<Test[]>([]);
    const [newTests, setNewTests] = useState<Test[]>([]);
    const [bundles, setBundles] = useState<Bundle[]>([]);
    const [numTests, setNumTests] = useState(null);

    const dispatch = useAppDispatch();

    useEffect(() => {
        axios.get('tests/digital/psat/')
            .then(res => {
                const {
                    myTests,
                    newTests,
                    bundles,
                    numTests
                } = res.data;
                
                setMyTests(myTests);
                setNewTests(newTests);
                setBundles(bundles);
                setNumTests(numTests);

                if (myTests.length === 0) setTabIndex(1);

                dispatch(updateClassroom({
                    tests: myTests
                }))
            })
            .catch(error => {
                dispatch(setAlert(error));
            });
    }, []);

    return (
        <div className='layout'>
            <Helmet
                title='Digital PSAT Practice Tests - The SAT Crash Course'
                description='Want to ace the Digital SAT? Take our 10+ practice tests that simulate the new digital SAT and receive personalized score analysis to prepare for the test.'
            />
            <div className='tests'>
                {myTests.length > 0 && newTests.length > 0 &&
                    <div className='tests__tabs'>
                        <button
                            className={tabIndex === 0 ? 'tests__tab--active' : 'tests__tab'}
                            onClick={() => setTabIndex(0)}
                        >
                            My Tests
                        </button>
                        <button
                            className={tabIndex === 1 ? 'tests__tab--active' : 'tests__tab'}
                            onClick={() => setTabIndex(1)}
                        >
                            Get New Tests
                        </button>
                        <div className={tabIndex === 0
                            ? 'tests__tabIndicatorLeft'
                            : 'tests__tabIndicatorRight'
                        }></div>
                    </div>
                }
                {tabIndex === 0
                    ?   <MyTests 
                            tests={myTests}
                        />
                    :   <NewTests
                            testType='Digital PSAT'
                            tests={newTests}
                            bundles={bundles}
                            numTests={numTests}
                        />
                }
            </div>
        </div>
    );
}

export default PSAT;